module.exports = __webpack_public_path__ + "img/arag_Anerkennung_der_Vaterschaft.1345855c.svg";